import { actionTypes } from '../constants';

const createInitialState = () => ({ search: '', current: undefined });

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.createReset: {
      return createInitialState();
    }

    case actionTypes.companySearchChanged: {
      return { ...state, search: payload };
    }

    case actionTypes.currentCompanyChanged: {
      return { ...state, current: payload };
    }

    default:
      return state;
  }
};
